import './App.css';
import LeftBar from './components/LeftBar';
import logo from './assets/logo.png';
import { ReactComponent as MenuIcon } from './assets/menu.svg'

import Section1 from './pages/Section1';
import Section2 from './pages/Section2';
import Section3 from './pages/Section3';
import Section4 from './pages/Section4';
import Section5 from './pages/Section5';
import Section6 from './pages/Section6';
import Section7 from './pages/Section7';
import Section8 from './pages/Section8';
import Section9 from './pages/Section9';
import Section10 from './pages/Section10';
import Section11 from './pages/Section11';
import Section12 from './pages/Section12';
import Section13 from './pages/Section13';
import Section14 from './pages/Section14';
import Section15 from './pages/Section15';
import Section16 from './pages/Section16';
import Section17 from './pages/Section17';
import Section18 from './pages/Section18';
import Section19 from './pages/Section19';

function App() {
        const handleMenuClick = () => {
                const menu = document.querySelector('.left-bar-container');

                if (menu && menu.classList.contains('active')) {
                        menu.classList.remove('active');
                } else if (menu) {
                        menu.classList.add('active')
                };
        }
        return (
                <div className="container">
                        <LeftBar />
                        <div className="menu-bg"></div>
                        <div className="top-menu-bar">
                                <div></div>
                                <img src={logo} width={150} alt="logo" />
                                <button onClick={handleMenuClick}><MenuIcon width={20} height={20} /></button>
                        </div>
                        <div className="boxes-container-outer">
                                <div className="boxes-container">

                                        <Section1 />
                                        <Section2 />
                                        <Section3 />
                                        <Section4 />
                                        <Section5 />
                                        <Section6 />
                                        <Section7 />
                                        <Section8 />
                                        <Section9 />
                                        <Section10 />
                                        <Section11 />

                                        <Section12 />
                                        <Section13 />
                                        <Section14 />
                                        <Section15 />
                                        <Section16 />
                                        <Section17 />
                                        <Section18 />
                                        <Section19 />
                                </div>
                        </div>
                </div>
        );
}

export default App;